import { render, staticRenderFns } from "./CursorMove.vue?vue&type=template&id=13c89f91&"
import script from "./CursorMove.vue?vue&type=script&lang=js&"
export * from "./CursorMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports